module.exports = __webpack_public_path__ + "img/3.acd86e56.jpg";